import React from "react";
import environments from "../../../../environments";
import { TransladoInternoBodyStandard } from "./providers/standard";
import { TransladoInternoBodyIpiranga } from "./providers/ipiranga";
import { ICemeteryResponse } from "../../../../shared/providers/cemetery/entities/cemetery.interface";

export interface TransladoInternoProps {
    cemeteryInfo: ICemeteryResponse;
    deceasedSubscription: string | undefined;
}

export const TransladoInternoBody: React.FC<TransladoInternoProps> = ({
    cemeteryInfo,
    deceasedSubscription,
}) => {
    switch (environments.client.name) {
        case "ipiranga":
            return (
                <TransladoInternoBodyIpiranga
                    cemeteryInfo={cemeteryInfo}
                    deceasedSubscription={deceasedSubscription}
                />
            );
        default:
            return (
                <TransladoInternoBodyStandard
                    cemeteryInfo={cemeteryInfo}
                    deceasedSubscription={deceasedSubscription}
                />
            );
    }
};
